import React, { useState, useEffect, useMemo } from 'react';
import { useTable } from 'react-table';
import { FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './UpdateSpecialist.css';

const UpdateSpecialist = () => {
    const navigate = useNavigate();
    const [specialistList, setSpecialistList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [newSpecialist, setNewSpecialist] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/getSpecialists?_=${new Date().getTime()}`);
            const jsonData = await response.json();
            setSpecialistList(jsonData);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching specialist data:', error.message);
        }
    };

    const handleInputChange = (e, index) => {
        const updatedList = [...specialistList];
        updatedList[index].Specialists = e.target.value;
        setSpecialistList(updatedList);
    };

    const handleAddSpecialist = () => {
        if (newSpecialist.trim()) {
            setSpecialistList([...specialistList, { Specialists: newSpecialist }]);
            setNewSpecialist('');
        } else {
            alert('Please provide a specialist name');
        }
    };

    const handleDeleteSpecialist = (index) => {
        const updatedList = [...specialistList];
        updatedList.splice(index, 1);
        setSpecialistList(updatedList);
    };

    const handleSave = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_AIRPORT_PICKUP_SERVER}/api/updateSpecialists`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(specialistList),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error saving specialist data');
            }

            alert('Data updated successfully');
            navigate('/adminPortal');
        } catch (error) {
            console.error('Error saving specialist data:', error.message);
        }
    };

    const handleCancel = () => {
        navigate('/adminPortal');
    };

    const columns = useMemo(() => [
        {
            Header: 'Specialists',
            accessor: 'Specialists',
            Cell: ({ value, row: { index } }) => (
                <input
                    type="text"
                    value={value}
                    onChange={(e) => handleInputChange(e, index)}
                />
            ),
        },
        {
            Header: 'Actions',
            Cell: ({ row: { index } }) => (
                <div>
                    <FaTrashAlt onClick={() => handleDeleteSpecialist(index)} />
                </div>
            ),
        },
    ], [specialistList]);

    const tableInstance = useTable({ columns, data: specialistList });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance;

    return (
        <div className="container">
            <h2>Specialist List</h2>
            {isLoading ? (
                <p>Loading...</p>
            ) : (
                <div>
                    <table className="table" {...getTableProps()}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map(row => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => (
                                            <td {...cell.getCellProps()}>
                                                {cell.render('Cell')}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}
                            <tr>
                                <td>
                                    <input
                                        type="text"
                                        value={newSpecialist}
                                        onChange={(e) => setNewSpecialist(e.target.value)}
                                        placeholder="New Specialist Name"
                                    />
                                </td>
                                <td>
                                    <button className="add-button" onClick={handleAddSpecialist}>Add</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        <button className="save-button" onClick={handleSave}>Save</button>
                        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
                        </div>
                        <div style={{  marginBottom: '100px' }}/>
                </div>
            )}
        </div>
    );
};

export default UpdateSpecialist;